import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Colouring",
  "description": "",
  "published": "2006-05-07T00:00:00.000Z",
  "redirect_from": ["/blog/colouring/swizec/420"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sneeks/sneek1.jpg",
        "alt": "Sneek peak"
      }}></img></p>
    <p>{`Glad to announce that the penciling for the whole comic has been finished and the colouring was commenced. This will take some time but presumably the comic should be up by the middle of the week or something like that. The image you can see above is a sneek peak from the comic, it is to be the last panel, though currently without speech bubbles and probably not completely the last version.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      